import { ChangeDetectorRef, Component, OnDestroy, OnInit } from '@angular/core';
import { Subject } from 'rxjs';
import { StepIds } from '../../../models/motors-step/motors-step-model';
import { MotorsDraftFacade } from '@classifieds-sell/state';
import { MotorsSectionBase } from '../../motors-section-base';
import { DatePipe } from '@angular/common';
import { AuctionTypeEnum, VehicleTransferOptionsEnum } from 'libs/datalayer/src/lib/enums/motors-sell-types';
import { getSummarySectionLinkText } from '../../../helpers/summary-page.helper';
import { ActivatedRoute } from '@angular/router';

@Component({
    selector: 'motors-summary-page-auction-details-section',
    templateUrl: './summary-page-auction-details-section.component.html',
    styleUrls: ['./summary-page-auction-details-section.component.scss']
})
export class SummaryPageAuctionDetailsSectionComponent
    extends MotorsSectionBase
    implements OnInit, OnDestroy {
    stepIds = StepIds;
    startPrice: string;
    reservePrice: string;
    buyNowPrice: string;
    authenticatedUsersOnly: boolean;
    duration: string;
    packageOption: string;
    vehicleTransferOptions: string;
    acceptedPayment: string;
    otherPayment: string;
    isAuction: boolean;
    summarySectionLinkText: string;
    acceptedPayments_Other: boolean;

    private _destroyed$: Subject<void> = new Subject<void>();

    constructor(
        draftFacade: MotorsDraftFacade,
        private route: ActivatedRoute,
        private _changeDetectorRef: ChangeDetectorRef,
        public datepipe: DatePipe
    ) {
        super(draftFacade);
    }

    ngOnDestroy(): void {
        super.onDestroy();
        this._destroyed$.next();
    }

    ngOnInit(): void {
        super.onInit(() => {
            this.buyNowPrice = this.priceString(this.draftData.listingDetails.buyNowPrice);
            this.startPrice = this.priceString(this.draftData.listingDetails.startPrice);
            this.reservePrice = this.priceString(this.draftData.listingDetails.reservePrice);
            this.isAuction = this.draftData.listingDetails.auctionType === AuctionTypeEnum.auctionAndBuyNow;
            this.authenticatedUsersOnly = this.draftData.listingDetails.allowBidsFromAuthenticatedUsersOnly;
            this.duration = this.durationText();
            this.packageOption = this.packageOptionText();
            this.vehicleTransferOptions = this.vehicleTransferOptionsText();
            this.acceptedPayment = this.acceptedPaymentsText();
            this.acceptedPayments_Other = this.draftData.listingDetails.acceptedPayments_Other;
            this.otherPayment = this.otherPaymentsText();
            this.summarySectionLinkText = getSummarySectionLinkText(this.route);

            this._changeDetectorRef.markForCheck();
           });
    }

    isValid(): boolean {
        return true;
    }

    dirty(): boolean {
        return false;
    }

    priceString(price: any): string {
        return price == null
            ? ''
            : '$' + price.toLocaleString('en-nz', {minimumFractionDigits: 2});
    }

    durationText(): string {
        return 'Closes ' + this.timeString() + ', ' + this.dateString();
    }

    timeString(): string{
        const endTime = this.draftData.listingDetails.endTime;
        return this.metadata.auctionTimes.find((t) => t.value === endTime).display.toLocaleUpperCase();
    }

    dateString(): string{
        const endDate = this.draftData.listingDetails.endDate;
        return this.datepipe.transform(endDate, 'dd/MM/yyyy');
    }

    packageOptionText(): string {
        const packageId = this.draftData.listingDetails.categoryPackageId;
        return this.metadata.fees.find((p) => p.id === packageId).name;
    }

    vehicleTransferOptionsText(): string {
        const transferOption = this.draftData.listingDetails.vehicleTransferOption;
        return transferOption === VehicleTransferOptionsEnum.buyerMustPickUp ? 'Buyer must pick up'
            : transferOption === VehicleTransferOptionsEnum.buyerCanPickUp ? 'Buyer can pick up'
            : transferOption === VehicleTransferOptionsEnum.toBeArranged ? 'To be arranged'
            : '';
    }

    acceptedPaymentsText(): string {
        const arr: string[] = [];
        if(this.draftData.listingDetails.acceptedPayments_Cash === true){
            arr.push('Cash');
        }
        if(this.draftData.listingDetails.acceptedPayments_NZBank === true){
            arr.push('NZ bank deposit');
        }
        return arr.join(', ');
    }

    otherPaymentsText(): string {
        return this.draftData.listingDetails.acceptedPayments_Other === null
            ? null
            : 'Other: '+this.draftData.listingDetails.otherPaymentDescription;
    }
}
